(function(){
    "use strict";

    /**
     * process selector input
     */
    window.addEventListener('message', function(e) {
        if (!e.data) return;

        let dataStr = e.data;

        if (typeof dataStr !== 'string') {
            return;
        }
        if (dataStr.startsWith('eventgalleryFlickrAlbum_')) {
            var data = JSON.parse(dataStr.replace('eventgalleryFlickrAlbum_',''));

            let albumField = document.getElementById('foldertype-2-photosetid')
            albumField.value = data.albumid;

            let titleField = document.getElementById('foldertype-2-title');
            titleField.value = data.title;

            albumField.onchange();
            titleField.onchange();

            //Joomla 4 button
            let closeBtn = document.querySelector('#flickr-album-selector-modal .modal-header button.btn-close');
            if (!closeBtn) {
                // Joomla 3 button
                closeBtn = document.querySelector('#flickr-album-selector-modal .modal-header button.close');
            }
            closeBtn.click();
        }
    });


})();
